<div class="h-full flex flex-col justify-center items-center">
  <mic-empty-state icon="gpp_maybe" title="Permissões insuficientes" subtitle="Seu perfil não possui as permissões necessárias para acessar essa página"> </mic-empty-state>
</div>
